<template>
  <div class="panel-common">
      <el-collapse-item class="panel-title" title="通用属性" label-position="top">
        <el-form class="form">
          <el-form-item label="安全报表" class="switch-right">
            <el-switch v-model="securityEnable" @change="changeSecurityEnable"/>
          </el-form-item>
          <el-form-item label="高级筛选" class="switch-right">
            <el-switch v-model="advancedFilter" @change="changeAdvancedFilter"/>
          </el-form-item>
          <el-form-item label="条件必填" class="switch-right condition-required">
            <el-tooltip content="条件必填开启后，报表将在所有查询条件都有值后才执行查询显示数据，若关闭，则默认展示所有数据。" placement="top" class="tooltip">
              <span class="fa fa-question-circle"></span>
            </el-tooltip>
            <el-switch v-model="conditionsRequired" @change="changeConditionsRequired"/>
          </el-form-item>
          <el-form-item class="switch-right" label="开启APP" :class="appOff?'line':''" v-if="Boolean(isOpenAppSwitch)!==true">
             <el-switch v-model="appOff" @change="changeAppModelOff"/>
          </el-form-item>
          <el-form-item v-if="appOff" label="模块名称" class="mb">
            <el-input v-model="appModel.moduleName"></el-input>
          </el-form-item>
          <app-model v-if="appOff" :model="appModel" :type="'模块'"></app-model>
          <el-form-item class="switch-right" v-if="appOff" label="默认在工作台">
            <el-checkbox v-model="appModel.workbenchType"></el-checkbox>
          </el-form-item>
          <el-form-item label="开启批量处理" class="switch-right" v-if="Boolean(isOpenAppSwitch)!==true">
            <el-switch v-model="batchHandle" @change="changeBatchHandle"/>
          </el-form-item>
          <el-form-item label="打开时不加载数据" class="switch-right" v-if="Boolean(isOpenAppSwitch)!==true">
            <el-switch v-model="openStartLoadData" @change="changeOpenStartLoadData"/>
          </el-form-item>
          <el-form-item label="报表行间隔背景色" class="switch-right" v-if="Boolean(isOpenAppSwitch)!==true">
            <el-switch v-model="bgColor" @change="changeBgColor"/>
          </el-form-item>
          <el-form-item label="分页大小" class="switch-right" v-if="Boolean(isOpenAppSwitch)!==true">
             <el-select v-model="pageNumber" class="page-number" @change='changePageNumber'>
                <el-option label="5" :value="5"></el-option>
                <el-option label="10" :value="10"></el-option>
                <el-option label="15" :value="15"></el-option>
                <el-option label="20" :value="20"></el-option>
                <el-option label="30" :value="30"></el-option>
                <el-option label="50" :value="50"></el-option>
                <el-option label="100" :value="100"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="操作列固定在首列" class="switch-right">
            <el-switch v-model="operationPosition" @change="changeOperationPosition"/>
          </el-form-item>
          <el-form-item label="组合报表">
            <el-select :popper-class="'groupReport'" :disabled="!isGroupReportSign"
              v-model="groupReportData"
              class="group-report"
              :multiple-limit="9"
              value-key="id"
              placeholder="请选择"
              multiple
              filterable
              @change="changeGroupReportData">
              <el-option v-for='item in allReports'
                         :key='item.id'
                         :label='item.name'
                         :value='item'>
              </el-option>
            </el-select>
            <i class="el-icon-sort group-sort" v-show="groupReportData.length>1" @click="sortGroup"></i>
          </el-form-item>
          <el-form-item label="合并相同单元格" v-if="Boolean(isOpenAppSwitch)!==true">
            <el-tooltip content="被选择的字段，相同内容的单元格将会合并展示" placement="top" class="tooltip">
             <span class="fa fa-question-circle"></span>
            </el-tooltip>
             <el-select
              v-model="mergeSame"
              multiple
              filterable
              class="group-report"
              @change="changeMergeSame">
              <el-option v-for='column in columns'
                         :key='column.id'
                         :label='column.name'
                         :value='column.id'>
               </el-option>
             </el-select>
          </el-form-item>
          <el-form-item class="switch-right">
            <span slot="label" style="font-size: 12px;">
              开启列编辑&nbsp;&nbsp;
              <el-tooltip content="开启列编辑,选择列字段后可对报表列进行编辑" placement="top" class="tooltip" popper-class="report-edit-tooltip">
               <span class="fa fa-question-circle"></span>
              </el-tooltip>
            </span>
            <el-switch v-model="columnEdit" @change="startColumnEdit"/>
          </el-form-item>
          <el-form-item label="选择表单" v-if="columnEdit">
            <el-select v-model="editColumnForm"
                       class="group-report"
                       value-key="id"
                       placeholder="请选择"
                       filterable
                       @change="selectEditColumnForm">
              <el-option v-for='item in selectForms'
                         :key='item.id'
                         :label='item.name'
                         :value='item.id'>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择编辑列" v-if="columnEdit && editColumnForm">
            <el-select v-model="editColumns"
                       class="select-edit-column"
                       value-key="id"
                       placeholder="请选择"
                       filterable
                       multiple
                       collapse-tags
                       @change="selectEditColumns">
              <el-option v-for='item in getOptions'
                         :key='item.id'
                         :label='item.name'
                         :value='item'>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <sort v-if="dialog.visible" :dialog="dialog" @saveSortList="saveGroupList"></sort>
</div>
</template>

<script>
import AppModel from '../../shared/openApp/app-model.vue'
import Sort from './sort.vue'
export default {
  name: 'CommonPanel',
  inject: ['reportService'],
  data () {
    let securityEnable = this.$_.clone(this.reportService.report.securityEnable)
    let advancedFilter = this.$_.clone(this.reportService.report.advancedFilter)
    let conditionsRequired = this.$_.clone(this.reportService.report.conditionsRequired)
    let appOff = this.$_.clone(this.reportService.report.appSwitch)
    let appModel = this.$_.clone(this.reportService.report.appModel)
    let batchHandle = this.$_.clone(this.reportService.report.batchHandle)
    let openStartLoadData = this.$_.clone(this.reportService.report.openStartLoadData)
    let bgColor = this.$_.clone(this.reportService.report.bgColor)
    let pageNumber = this.$_.clone(this.reportService.report.pageNumber)
    let operationPosition = this.$_.clone(this.reportService.report.operationPosition)
    let groupReportData = this.$_.clone(this.reportService.report.groupReportData) || []
    let mergeSame = this.$_.clone(this.reportService.report.mergeSame) || []
    let columns = this.$_.clone(this.reportService.report.columns)
    let columnEdit = this.$_.clone(this.reportService.report.columnEdit)
    let editColumns = this.$_.clone(this.reportService.report.editColumns) || []
    let editColumnForm = this.$_.clone(this.reportService.report.editColumnForm)
    return {
      securityEnable,
      advancedFilter,
      conditionsRequired,
      appOff,
      appModel,
      isOpenAppSwitch: this.$route.query.dataSourceReport || this.reportService.report.dataSourceReport,
      batchHandle,
      pageNumber,
      groupReportData,
      allReports: [],
      dialog: {
        visible: false,
        isClick: '',
        sortLists: [],
        title: '组合顺序'
      },
      operationPosition,
      openStartLoadData,
      bgColor,
      isGroupReportSign: this.reportService.report.isGroupReportSign,
      mergeSame,
      columns,
      columnEdit,
      editColumns,
      editColumnForm,
      selectForms: [],
      allComponent: {}
    }
  },
  components: {
    AppModel,
    Sort
  },
  watch: {
    appModel: {
      handler (value) {
        this.$emit('updataAppModel', value)
      },
      deep: true
    }
  },
  created () {
    this.getAllFilterGroutReport()
    this.getFormWithMainTableId()
    this.reportService.report.editColumnForm && this.getColumnsWithMainTableId(this.reportService.report.editColumnForm)
  },
  methods: {
    getAllFilterGroutReport () {
      this.$axios(`/report-api/report/definition/notGroupReports`).then(res => {
        this.allReports = res.data.map(m => this.$_.pick(m, ['id', 'name']))
        let cloneGroup = this.$_.cloneDeep(this.groupReportData)
        cloneGroup.reverse().forEach(m => {
          let groupReport = this.allReports.find(n => n.id === m.id)
          if (!groupReport) this.allReports.unshift(m)
        })
        let currentReport = this.allReports.find(n => n.id === this.reportService.report.id)
        let currentReportIndex = this.allReports.findIndex(n => n.id === this.reportService.report.id)
        let name = this.reportService.report.name ? this.reportService.report.name : '本报表'
        if (!currentReport) {
          this.allReports.unshift({id: this.reportService.report.id, name: name})
        } else {
          this.groupReportData.find(n => n.id === this.reportService.report.id).name = name
          this.allReports.splice(currentReportIndex, 1)
          this.allReports.unshift({id: this.reportService.report.id, name: name})
        }
      })
    },
    changeSecurityEnable (securityEnable) {
      this.$emit('updateSecurityEnable', securityEnable)
    },
    changeAdvancedFilter (advancedFilter) {
      this.$emit('updateAdvancedFilter', advancedFilter)
    },
    changeConditionsRequired (conditionsRequired) {
      this.$emit('updateConditionsRequired', conditionsRequired)
    },
    changeAppModelOff (off) {
      this.$emit('updateAppModelOff', off)
    },
    changeBatchHandle (off) {
      this.$emit('updateBatchHandle', off)
    },
    changePageNumber (number) {
      this.$emit('updatePageNumber', number)
    },
    changeOperationPosition (position) {
      this.$emit('updateOperationPosition', position)
    },
    changeOpenStartLoadData (state) {
      this.$emit('updateOpenStartLoadData', state)
    },
    changeBgColor (state) {
      this.$emit('updateBgColor', state)
    },
    changeGroupReportData (groupReportData) {
      let currentRport = groupReportData.find(m => m.id === this.reportService.report.id)
      // 本报表不允许取消
      if (!currentRport) {
        this.groupReportData.unshift({id: this.reportService.report.id, name: this.reportService.report.name || '本报表'})
      }
      this.$emit('updateGroupReportData', groupReportData)
    },
    changeMergeSame (mergeSame) {
      this.$emit('updateMergeSame', mergeSame)
    },
    sortGroup () {
      this.dialog.sortLists = this.groupReportData
      this.dialog.visible = true
    },
    saveGroupList (sortList) {
      this.groupReportData = sortList
      this.$emit('updateGroupReportData', this.groupReportData)
      this.dialog.visible = false
    },
    startColumnEdit (state) {
      this.$emit('updateColumnEdit', state)
      if (state) {
        // 如果只有一个归档表，则默认选中
        if (this.selectForms && this.selectForms.length === 1) {
          this.editColumnForm = this.selectForms[0].id
          this.selectEditColumnForm(this.selectForms[0].id)
        }
      }
    },
    selectEditColumns (arr) {
      this.$emit('updateEditColumns', arr)
    },
    selectEditColumnForm (id) {
      this.$emit('updateEditColumnForm', id)
      // 根据表单加载表单定义
      this.getColumnsWithMainTableId(id)
    },
    getFormWithMainTableId () {
      this.$axios.get(`/form-api/defines/findFormByArchivedId/${this.reportService.report.mainTableId}`).then(res => {
        this.selectForms = res.data
      })
    },
    async getColumnsWithMainTableId (id) {
      await this.$axios.get(`/form-api/defines/${id}`).then(res => {
        // 只允许修改的控件类型为 数字框、文本框、下拉框、日期框、大文本框
        // 没有归档的控件不会生成列
        this.allComponent = this.reportService.getAllComponent(res.data.form.form.children).filter(m => m.archive.columnId && (m.componentType === 'rc-numeric' || m.componentType === 'rc-input' || m.componentType === 'rc-combobox' || m.componentType === 'rc-date' || m.componentType === 'rc-textarea' || m.componentType === 'rc-rich-box'))
      })
    }
  },
  computed: {
    getOptions () {
      if (this.allComponent && this.allComponent.length > 0) {
        let table = this.reportService.getReportJoinTables().find(t => t.id === this.reportService.report.mainTableId)
        if (table) {
          // 找出所有的可编辑的归档列
          let archiveColumn = table.columns.filter(c => this.allComponent.find(m => m.archive.columnId === c.id))
          // 所有的报表列
          let column = this.$_.cloneDeep(this.reportService.report.columns)
          // 过滤可选的报表列
          column = column.filter(c => archiveColumn.find(m => m.id === c.columnId))
          // 有计算的值 不编辑
          column = column.filter(c => !c.summary)
          // 处理数据
          column = column.map(m => {
            let component = this.allComponent.find(c => m.columnId === c.archive.columnId || m.columnId === JSON.parse(c.properties).archived.showColumnId)
            let combobxShowColumnId = ''
            let name = m.name
            let id = m.id
            let combobxColumnId = ''
            // 如果是数据源下拉框
            if (component.componentType === 'rc-combobox' && JSON.parse(component.properties).dataSource.enable) {
              combobxShowColumnId = JSON.parse(component.properties).archived.showColumnId
              // 找到该列所对应的name
              let column = this.reportService.report.columns.find(r => r.columnId === combobxShowColumnId)
              if (column) {
                name = column.name
                id = column.id
                combobxColumnId = m.id
              } else {
                return null
              }
            }
            return {
              // 列 id
              id,
              // 控件id
              componentId: component.id,
              // 控件类型
              componentType: component.componentType,
              // 下拉框ID归档id
              combobxShowColumnId,
              // 下拉框ID的列id
              combobxColumnId,
              name,
              // 归档id
              columnId: component.archive.columnId
            }
          })
          // 如果只选了下拉框id没有选下拉框内容，则过滤该下拉框
          column = this.$_.compact(column)
          // 如果 选了的column中 包含有计算的列，直接删除
          if (this.editColumns && this.editColumns.length) {
            let editColumns = this.$_.cloneDeep(this.editColumns)
            editColumns = editColumns.filter(c => column.find(f => f.id === c.id))
            this.$set(this, 'editColumns', editColumns)
            this.selectEditColumns(editColumns)
          }
          return column
        }
      }
    }
  }
}
</script>

<style lang="scss">
.panel-common {
  .el-collapse-item__content {
    padding-bottom: 0;
    .el-form.form{
      .el-form-item__label{
        font-size: 12px;
      }
    }
  }
  .form{
    .switch-right.el-form-item {
      margin: 0 0 6px 0;
      .page-number {
        width:75px;
      }
      .el-form-item__content {
        float: right;
      }
    }

    .group-report {
      width: 164px;
      .el-select__tags {
        width: 155px;
        >span{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          max-width: 106px;
        }
        >.el-select__input {
            margin-left: 0px
          }
        .el-tag {
          margin: 0 4px;
          border-color: transparent;
          background: transparent;
        }
       }
    }
    .group-sort {
      cursor: pointer;
      color: #55ABF1;
      &:active {
         color: #388DD2;
      }
    }
    .el-tooltip__popper {
      width: 240px;
    }
    .condition-required {
       margin: 0;
      .el-tooltip {
        color: rgb(192,194,193);
        cursor: pointer;
        &:hover{
          color: #3a8ee6;
        }
     }
     .el-switch  {
       float: right;
       margin-top: 4px;
     }
    }
    .line {
      padding-bottom: 10px;
      border-bottom: 1px solid #E7E8E8;
    }
    .mb {
      margin-bottom: 24px;
    }
    .upload-click {
      border-radius: 50%;
    }
    .el-form-item {
      .el-form-item__content {
        .select-edit-column {
          width: 164px;
          .el-select__tags {
            & > span {
              .el-tag {
                max-width: 63px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
}
.report-edit-tooltip {
  left: 215px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/common-panel.vue